



























import {Component, Prop, Vue} from 'vue-property-decorator';

import OptionList from '@/components/OptionList.vue';
import Loading from '@/components/Loading.vue';
import SearchBox from '@/components/SearchBox.vue';
import GroupRow from '@/components/group/GroupRow.vue';
import ExpandButton from '@/components/ExpandButton.vue';
import VueError from '@/components/VueError.vue';
import PageNav from '@/components/PageNav.vue';
import NavBar from '@/components/NavBar.vue';
import EnrolDevice from '@/components/device/EnrolDevice.vue';
import tippy from "tippy.js";
import NumEntries from '@/components/NumEntries.vue';
import {Enterprise} from "@/types/core";


@Component({
  components: {
    GroupRow,
    OptionList,
    SearchBox,
    VueError,
    PageNav,
    Loading,
    NavBar,
    ExpandButton,
    EnrolDevice,
    NumEntries,
  },
})
export default class GroupList extends Vue {

  error:string = '';

  @Prop({ default: {}, type: Object}) enterprise!: Enterprise;
  @Prop({ default: 0, type: Number}) index!: number;
  @Prop({ default: {}, type: Object}) bus!: Vue;

  // first move is always to refresh Data
  httpBusy:boolean = true;
  expanded:boolean = true;


  async mounted() {
    // v-if impeding tippy
    await this.$nextTick()
    tippy('[data-tippy-content]');

    if (this.index === 0) {
      this.expanded = true;
    }
  }

  async refreshData() {
    this.error = '';
    this.httpBusy = true;
    this.httpBusy = false;
  }

  goToEnterprise() {
    this.bus.$emit('devices-search', this.enterprise.enterpriseId);
  }
}
